import { type LinkProps as RemixLinkProps } from '@remix-run/react'
import { Link as RemixLink } from '@remix-run/react'
import { useContext } from 'react'
import { shouldReloadDocument } from '@helpers/shouldReloadDocument'
import { EnvContext } from '@contexts/EnvContext'
import { useQueryStringPreservedUrl } from '@hooks/useQueryStringPreservedUrl'

export type LinkProps = {
  url: string
  baseUrl?: string
} & Omit<RemixLinkProps, 'to'>

export const Link = ({ url, baseUrl, ...rest }: LinkProps) => {
  const to = baseUrl ? `${baseUrl}${url}` : url

  const urlWithPreservedQueryStrigns = useQueryStringPreservedUrl(to)

  const env = useContext(EnvContext)
  const reloadDocument = shouldReloadDocument(to, env || 'live')

  return (
    <RemixLink
      {...rest}
      to={urlWithPreservedQueryStrigns}
      reloadDocument={reloadDocument}
    />
  )
}
